// @core/api/endpoints/team/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { AcceptRoleDelegation } from './accept_role_delegation';
import { AcceptTeamInvitation } from './accept_team_invitation';
import { AcknowledgeScheduleRotation } from './acknowledge_schedule_rotation';
import { ActivateTeamAvatar } from './activate_team_avatar';
import { AddScheduleParticipant } from './add_schedule_participant';
import { AddTeamMember } from './add_team_member';
import { ApproveTeamJoinApplication } from './approve_team_join_application';
import { ApproveTeamRoleApplication } from './approve_team_role_application';
import { AssignTeamPermissionToRole } from './assign_team_permission_to_role';
import { AssignTeamRole } from './assign_team_role';
import { CancelRoleDelegation } from './cancel_role_delegation';
import { CancelTeamInvitation } from './cancel_team_invitation';
import { CancelTeamJoinApplication } from './cancel_team_join_application';
import { CancelTeamOwnershipTransfer } from './cancel_team_ownership_transfer';
import { CancelTeamRoleApplication } from './cancel_team_role_application';
import { CancelTemporaryRoleAssignment } from './cancel_temporary_role_assignment';
import { CreateRoleDelegation } from './create_role_delegation';
import { CreateRoleSchedule } from './create_role_schedule';
import { CreateTeam } from './create_team';
import { CreateTeamAvatar } from './create_team_avatar';
import { CreateTeamBanner } from './create_team_banner';
import { CreateTeamInvitation } from './create_team_invitation';
import { CreateTeamJoinApplication } from './create_team_join_application';
import { CreateTeamOwnershipTransfer } from './create_team_ownership_transfer';
import { CreateTeamRole } from './create_team_role';
import { CreateTeamRoleApplication } from './create_team_role_application';
import { CreateTemporaryRoleAssignment } from './create_temporary_role_assignment';
import { DeclineTeamInvitation } from './decline_team_invitation';
import { DeleteRoleSchedule } from './delete_role_schedule';
import { DeleteTeam } from './delete_team';
import { DeleteTeamAvatar } from './delete_team_avatar';
import { DeleteTeamBanner } from './delete_team_banner';
import { DeleteTeamRole } from './delete_team_role';
import { ExtendRoleDelegation } from './extend_role_delegation';
import { GetCurrentScheduleAssignee } from './get_current_schedule_assignee';
import { GetRoleDelegation } from './get_role_delegation';
import { GetRoleSchedule } from './get_role_schedule';
import { GetTeam } from './get_team';
import { GetTeamAvatar } from './get_team_avatar';
import { GetTeamBanner } from './get_team_banner';
import { GetTeamDetails } from './get_team_details';
import { GetTeamJoinApplication } from './get_team_join_application';
import { GetTeamOwnershipTransfer } from './get_team_ownership_transfer';
import { GetTeamRoleApplication } from './get_team_role_application';
import { GetTeamSecuritySettings } from './get_team_security_settings';
import { GetTeamUISettings } from './get_team_ui_settings';
import { GetTeamUserSettings } from './get_team_user_settings';
import { GetTemporaryRoleAssignment } from './get_temporary_role_assignment';
import { GrantTeamOwnership } from './grant_team_ownership';
import { ListDelegatedToMe } from './list_delegated_to_me';
import { ListMyDelegations } from './list_my_delegations';
import { ListMyTeamInvitations } from './list_my_team_invitations';
import { ListMyTemporaryRoles } from './list_my_temporary_roles';
import { ListRoleAutomationEvents } from './list_role_automation_events';
import { ListRoleDelegations } from './list_role_delegations';
import { ListRoleSchedules } from './list_role_schedules';
import { ListTeamAvatars } from './list_team_avatars';
import { ListTeamInvitations } from './list_team_invitations';
import { ListTeamJoinApplications } from './list_team_join_applications';
import { ListTeamLogs } from './list_team_logs';
import { ListTeamMembers } from './list_team_members';
import { ListTeamOwnershipTransfers } from './list_team_ownership_transfers';
import { ListTeamPermissions } from './list_team_permissions';
import { ListTeamRoleApplications } from './list_team_role_applications';
import { ListTeamRoles } from './list_team_roles';
import { ListTeamUsersByRole } from './list_team_users_by_role';
import { ListTeams } from './list_teams';
import { ListTemporaryRoleAssignments } from './list_temporary_role_assignments';
import { PauseRoleSchedule } from './pause_role_schedule';
import { RejectRoleDelegation } from './reject_role_delegation';
import { RemoveScheduleParticipant } from './remove_schedule_participant';
import { RemoveTeamMember } from './remove_team_member';
import { RemoveTeamPermissionFromRole } from './remove_team_permission_from_role';
import { ResetTeamSecuritySettings } from './reset_team_security_settings';
import { ResetTeamUISettings } from './reset_team_ui_settings';
import { ResetTeamUserSettings } from './reset_team_user_settings';
import { ResumeRoleSchedule } from './resume_role_schedule';
import { RevokeTeamOwnership } from './revoke_team_ownership';
import { RevokeTeamRole } from './revoke_team_role';
import { TransferTeamOwnership } from './transfer_team_ownership';
import { TriggerScheduleRotation } from './trigger_schedule_rotation';
import { UpdateRoleDelegation } from './update_role_delegation';
import { UpdateRoleSchedule } from './update_role_schedule';
import { UpdateTeam } from './update_team';
import { UpdateTeamMemberRole } from './update_team_member_role';
import { UpdateTeamRole } from './update_team_role';
import { UpdateTeamSecuritySettings } from './update_team_security_settings';
import { UpdateTeamUISettings } from './update_team_ui_settings';
import { UpdateTeamUserRole } from './update_team_user_role';
import { UpdateTeamUserSettings } from './update_team_user_settings';
import { UpdateTemporaryRoleAssignment } from './update_temporary_role_assignment';

// Re-export individual endpoints
export {
  AcceptRoleDelegation,
  AcceptTeamInvitation,
  AcknowledgeScheduleRotation,
  ActivateTeamAvatar,
  AddScheduleParticipant,
  AddTeamMember,
  ApproveTeamJoinApplication,
  ApproveTeamRoleApplication,
  AssignTeamPermissionToRole,
  AssignTeamRole,
  CancelRoleDelegation,
  CancelTeamInvitation,
  CancelTeamJoinApplication,
  CancelTeamOwnershipTransfer,
  CancelTeamRoleApplication,
  CancelTemporaryRoleAssignment,
  CreateRoleDelegation,
  CreateRoleSchedule,
  CreateTeam,
  CreateTeamAvatar,
  CreateTeamBanner,
  CreateTeamInvitation,
  CreateTeamJoinApplication,
  CreateTeamOwnershipTransfer,
  CreateTeamRole,
  CreateTeamRoleApplication,
  CreateTemporaryRoleAssignment,
  DeclineTeamInvitation,
  DeleteRoleSchedule,
  DeleteTeam,
  DeleteTeamAvatar,
  DeleteTeamBanner,
  DeleteTeamRole,
  ExtendRoleDelegation,
  GetCurrentScheduleAssignee,
  GetRoleDelegation,
  GetRoleSchedule,
  GetTeam,
  GetTeamAvatar,
  GetTeamBanner,
  GetTeamDetails,
  GetTeamJoinApplication,
  GetTeamOwnershipTransfer,
  GetTeamRoleApplication,
  GetTeamSecuritySettings,
  GetTeamUISettings,
  GetTeamUserSettings,
  GetTemporaryRoleAssignment,
  GrantTeamOwnership,
  ListDelegatedToMe,
  ListMyDelegations,
  ListMyTeamInvitations,
  ListMyTemporaryRoles,
  ListRoleAutomationEvents,
  ListRoleDelegations,
  ListRoleSchedules,
  ListTeamAvatars,
  ListTeamInvitations,
  ListTeamJoinApplications,
  ListTeamLogs,
  ListTeamMembers,
  ListTeamOwnershipTransfers,
  ListTeamPermissions,
  ListTeamRoleApplications,
  ListTeamRoles,
  ListTeamUsersByRole,
  ListTeams,
  ListTemporaryRoleAssignments,
  PauseRoleSchedule,
  RejectRoleDelegation,
  RemoveScheduleParticipant,
  RemoveTeamMember,
  RemoveTeamPermissionFromRole,
  ResetTeamSecuritySettings,
  ResetTeamUISettings,
  ResetTeamUserSettings,
  ResumeRoleSchedule,
  RevokeTeamOwnership,
  RevokeTeamRole,
  TransferTeamOwnership,
  TriggerScheduleRotation,
  UpdateRoleDelegation,
  UpdateRoleSchedule,
  UpdateTeam,
  UpdateTeamMemberRole,
  UpdateTeamRole,
  UpdateTeamSecuritySettings,
  UpdateTeamUISettings,
  UpdateTeamUserRole,
  UpdateTeamUserSettings,
  UpdateTemporaryRoleAssignment,
};

// Namespace export for convenient usage
export const teamApi = {
  AcceptRoleDelegation,
  AcceptTeamInvitation,
  AcknowledgeScheduleRotation,
  ActivateTeamAvatar,
  AddScheduleParticipant,
  AddTeamMember,
  ApproveTeamJoinApplication,
  ApproveTeamRoleApplication,
  AssignTeamPermissionToRole,
  AssignTeamRole,
  CancelRoleDelegation,
  CancelTeamInvitation,
  CancelTeamJoinApplication,
  CancelTeamOwnershipTransfer,
  CancelTeamRoleApplication,
  CancelTemporaryRoleAssignment,
  CreateRoleDelegation,
  CreateRoleSchedule,
  CreateTeam,
  CreateTeamAvatar,
  CreateTeamBanner,
  CreateTeamInvitation,
  CreateTeamJoinApplication,
  CreateTeamOwnershipTransfer,
  CreateTeamRole,
  CreateTeamRoleApplication,
  CreateTemporaryRoleAssignment,
  DeclineTeamInvitation,
  DeleteRoleSchedule,
  DeleteTeam,
  DeleteTeamAvatar,
  DeleteTeamBanner,
  DeleteTeamRole,
  ExtendRoleDelegation,
  GetCurrentScheduleAssignee,
  GetRoleDelegation,
  GetRoleSchedule,
  GetTeam,
  GetTeamAvatar,
  GetTeamBanner,
  GetTeamDetails,
  GetTeamJoinApplication,
  GetTeamOwnershipTransfer,
  GetTeamRoleApplication,
  GetTeamSecuritySettings,
  GetTeamUISettings,
  GetTeamUserSettings,
  GetTemporaryRoleAssignment,
  GrantTeamOwnership,
  ListDelegatedToMe,
  ListMyDelegations,
  ListMyTeamInvitations,
  ListMyTemporaryRoles,
  ListRoleAutomationEvents,
  ListRoleDelegations,
  ListRoleSchedules,
  ListTeamAvatars,
  ListTeamInvitations,
  ListTeamJoinApplications,
  ListTeamLogs,
  ListTeamMembers,
  ListTeamOwnershipTransfers,
  ListTeamPermissions,
  ListTeamRoleApplications,
  ListTeamRoles,
  ListTeamUsersByRole,
  ListTeams,
  ListTemporaryRoleAssignments,
  PauseRoleSchedule,
  RejectRoleDelegation,
  RemoveScheduleParticipant,
  RemoveTeamMember,
  RemoveTeamPermissionFromRole,
  ResetTeamSecuritySettings,
  ResetTeamUISettings,
  ResetTeamUserSettings,
  ResumeRoleSchedule,
  RevokeTeamOwnership,
  RevokeTeamRole,
  TransferTeamOwnership,
  TriggerScheduleRotation,
  UpdateRoleDelegation,
  UpdateRoleSchedule,
  UpdateTeam,
  UpdateTeamMemberRole,
  UpdateTeamRole,
  UpdateTeamSecuritySettings,
  UpdateTeamUISettings,
  UpdateTeamUserRole,
  UpdateTeamUserSettings,
  UpdateTemporaryRoleAssignment,
};
